const FRANCHISE_ROLES = {
  OWNER: 1,
  MANAGER: 2,
  OFFICIAL: 3,
  DRAFT_MANAGER: 4,
  FAN: 5,
  NONE: 99,
};

const LEAGUE_ROLES = {
  OWNER: 1,
  COMMISH: 2,
  OFFICIAL: 3,
  MEMBER: 4,
  FAN: 5,
  NONE: 99,
};

const ROLE_TYPES = {
  FRANCHISE: "fr",
  LEAGUE: "lg",
  SITE: "st",
};

const SITE_ROLES = {
  SUPER_ADMIN: 1,
  ADMIN: 2,
  MODERATOR: 3,
  USER: 4,
  NONE: 99,
};

export { FRANCHISE_ROLES, LEAGUE_ROLES, ROLE_TYPES, SITE_ROLES };
